import { Controller } from "@hotwired/stimulus"
import {
  buildCalendarMonth,
  calendarEventsFor,
  monthValue,
  parseMonth,
  shiftMonth,
  upcomingCalendarEvents
} from "../shared/calendar_month_builder"

export default class extends Controller {
  static targets = ["month"]
  static values = { startMonth: String }

  connect() {
    this.events = upcomingCalendarEvents(calendarEventsFor(this.element))
    this.currentMonth = parseMonth(this.startMonthValue)
    this.hideIndividualNavigation()
  }

  previous(event) {
    event.preventDefault()
    this.changeMonths(-1)
  }

  next(event) {
    event.preventDefault()
    this.changeMonths(1)
  }

  changeMonths(offset) {
    if (this.monthTargets.length !== 2) return

    const firstMonth = shiftMonth(this.currentMonth, offset)
    const secondMonth = shiftMonth(this.currentMonth, offset + 1)
    const monthElements = [firstMonth, secondMonth].map((month) => {
      return buildCalendarMonth({
        month,
        events: this.events,
        variant: "service",
        hideNavigation: true,
        compact: true
      })
    })

    this.element.classList.add("opacity-60")
    requestAnimationFrame(() => {
      this.monthTargets.forEach((target, index) => {
        target.replaceChildren(monthElements[index])
      })
      this.currentMonth = parseMonth(monthValue(firstMonth))
      this.element.classList.remove("opacity-60")
    })
  }

  hideIndividualNavigation() {
    this.monthTargets.forEach((month) => {
      month.querySelectorAll(".calendar-heading > a").forEach((link) => link.remove())
    })
  }
}
